import apiService from './api';
import { ReceivedAmount } from '../types/invoiceTypes';

class ReceivedAmountService {
  // Get all received amounts
  async getAll(): Promise<ReceivedAmount[]> {
    const response = await apiService.get<ReceivedAmount[]>('/received-amounts');
    return response.data;
  }

  // Get a single received amount by ID
  async getById(id: string): Promise<ReceivedAmount> {
    const response = await apiService.get<ReceivedAmount>(`/received-amounts/${id}`);
    return response.data;
  }

  // Create a new received amount
  async recordPayment(data: ReceivedAmount): Promise<ReceivedAmount> {
    const response = await apiService.post<ReceivedAmount>('/received-amounts', data);
    return response.data;
  }

  // Update a received amount
  async update(id: string, data: Partial<ReceivedAmount>): Promise<ReceivedAmount> {
    const response = await apiService.put<ReceivedAmount>(`/received-amounts/${id}`, data);
    return response.data;
  }

  // Delete a received amount
  async delete(id: number): Promise<void> {
    await apiService.delete(`/received-amounts/${id}`);
  }

  async getByDate(date: string): Promise<ReceivedAmount[]> {
    const response = await apiService.get<ReceivedAmount[]>(`/received-amounts/by-date?date=${date}`);
    return response.data;
  }

  async getFiltered(query: string): Promise<ReceivedAmount[]> {
    const response = await apiService.get<ReceivedAmount[]>(`/received-amounts/by-date?${query}`);
    return response.data;
  }
}

export const receivedAmountService = new ReceivedAmountService();
export default receivedAmountService;